import { render, staticRenderFns } from "./ReportDetails.vue?vue&type=template&id=3b3e0c7b&scoped=true&"
import script from "./ReportDetails.vue?vue&type=script&lang=js&"
export * from "./ReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetails.vue?vue&type=style&index=0&id=3b3e0c7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3e0c7b",
  null
  
)

export default component.exports